<div class="agent-customer-quick-create" *ngIf="hasUsefulSignal">

  <div class="p-3 border-round surface-100" *ngIf="state === 'existing-match'">
    <div>
      Схожий контакт вже є в списку співробітників:
      <strong>{{ matchedExisting?.PERSONLNAME }} {{ matchedExisting?.PERSONFNAME }}</strong>
      ({{ matchedExisting?.PERSONEMAIL || matchedExisting?.PERSONPHONE }}).
    </div>
    <p-button label="Використати цей контакт" styleClass="p-button-text p-button-sm mt-2"
              (onClick)="useExistingContact()"></p-button>
  </div>

  <div class="fluid grid" *ngIf="state !== 'existing-match'">
    <div class="col-12">
      <p-tag severity="info" [value]="mode === 'new-company' ? 'Нова організація з листа' : 'Новий контакт з листа'"
             styleClass="mb-2"></p-tag>
      <div class="text-500 text-sm mb-2">
        Дані нижче — з підпису листа, розпізнані AI. Перевірте перед збереженням.
      </div>
    </div>

    <ng-container *ngIf="mode === 'new-company'">
      <div class="field col-6">
        <label class="block">Коротка назва</label>
        <input type="text" pInputText [(ngModel)]="companyNickname" class="w-full" [disabled]="state === 'saving'"
               placeholder="Без лапок і форми власності, напр. АБР Електрик">
      </div>
      <div class="field col-6">
        <label class="block">Код ЄДРПОУ</label>
        <input type="text" pInputText [(ngModel)]="registrationCode" class="w-full" [disabled]="state === 'saving'">
      </div>
      <div class="field col-12">
        <label class="block">Назва організації</label>
        <input type="text" pInputText [(ngModel)]="companyName" class="w-full" [disabled]="state === 'saving'">
      </div>
      <div class="field col-4">
        <label class="block">Поштовий індекс</label>
        <input type="text" pInputText [(ngModel)]="zip" class="w-full" [disabled]="state === 'saving'">
      </div>
      <div class="field col-4">
        <label class="block">Країна</label>
        <input type="text" pInputText [(ngModel)]="country" class="w-full" [disabled]="state === 'saving'">
      </div>
      <div class="field col-4">
        <label class="block">Місто</label>
        <input type="text" pInputText [(ngModel)]="city" class="w-full" [disabled]="state === 'saving'">
      </div>
      <div class="field col-12">
        <label class="block">Адреса організації (вулиця, будинок)</label>
        <input type="text" pInputText [(ngModel)]="street" class="w-full" [disabled]="state === 'saving'">
      </div>
    </ng-container>

    <div class="field col-6">
      <label class="block">Ім'я контакту</label>
      <input type="text" pInputText [(ngModel)]="firstName" class="w-full" [disabled]="state === 'saving'">
    </div>
    <div class="field col-6">
      <label class="block">Прізвище контакту</label>
      <input type="text" pInputText [(ngModel)]="lastName" class="w-full" [disabled]="state === 'saving'">
    </div>
    <div class="field col-6">
      <label class="block">Телефон</label>
      <input type="text" pInputText [(ngModel)]="phone" class="w-full" [disabled]="state === 'saving'">
    </div>
    <div class="field col-6">
      <label class="block">E-mail</label>
      <input type="text" pInputText [(ngModel)]="email" class="w-full" [disabled]="state === 'saving'">
    </div>

    <div class="col-12" *ngIf="state !== 'contact-save-failed'">
      <p-button
        [label]="mode === 'new-company' ? 'Створити організацію' : 'Додати контакт'"
        icon="pi pi-plus" [loading]="state === 'saving'"
        (onClick)="onCreate()"></p-button>
    </div>

    <div class="col-12" *ngIf="state === 'contact-save-failed'">
      <div class="p-error mb-2">Організацію створено, але контакт не збережено.</div>
      <p-button label="Повторити збереження контакту" icon="pi pi-refresh"
                (onClick)="retryContact()"></p-button>
    </div>
  </div>
</div>
